import Vue from 'vue';
import { VueIntersection, stat } from '@qsk/slime-core';
import GioClick from './click';
import { gioTrackByList } from '../utils/gio';

Vue.use(GioClick);

// 曝光模块，单页统一处理
Vue.use(VueIntersection, {
  handler: (logData = {}) => {
    let data = logData;
    // v1
    if (data.gioActionData) {
      if (window.gio) window.gio('track', data.gioActionData.action, data.gioActionData.dataStr);
      delete data.gioActionData;
    }
    // v2
    data = gioTrackByList('view', data);
    const { banShow } = data;
    delete data.banShow;
    delete data.event;
    if (!banShow && data && data.obj_id) {
      stat.track('show', data);
    }
  },
  duration: 1000, // 在页面可视区域停留时长
});
